/** ID do elemento script injetado pelo loader do SDK Facebook JS. */
export const FACEBOOK_SDK_SCRIPT_ID = "facebook-jssdk";

/** Locale padrão do SDK (`connect.facebook.net/{locale}/sdk.js`). */
export const FACEBOOK_SDK_DEFAULT_LOCALE = "pt_BR";

/** Versão da Graph API usada no `FB.init`. */
export const FACEBOOK_SDK_DEFAULT_VERSION = "v25.0";

/** Tempo máximo de espera até `window.FB` ficar disponível após injetar o script. */
export const FACEBOOK_SDK_WAIT_TIMEOUT_MS = 15_000;

/**
 * Extras do `FB.login` para Embedded Signup com onboarding via WhatsApp Business app.
 * @see https://developers.facebook.com/docs/whatsapp/embedded-signup/custom-flows/onboarding-business-app-users/
 */
export const META_EMBEDDED_SIGNUP_LOGIN_EXTRAS = {
  setup: {},
  feature: "whatsapp_embedded_signup",
  sessionInfoVersion: "3",
  featureType: "whatsapp_business_app_onboarding",
} as const;
